import { FiCode } from 'react-icons/fi'

import Panel from '~/components/Panel'

export const CurlCommand = ({ data }: { data: string }) =>
  data ? (
    <Panel
      iconLeft={<FiCode />}
      title="CURL command"
      isCollapsible
      initialCollapsibleState={false}
    >
      <code>
        <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
          {data}
        </pre>
      </code>
    </Panel>
  ) : (
    <></>
  )
